//moment(new Date()).format("Do MMMM")
export const addAdminEmail = (email, adminLevel) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(email, adminLevel);
      firestore
        .collection("adminmails")
        .add(  
          {
            email,
            adminLevel
          }
        )
        .then(() => {
            ///console.log('kkk')
          dispatch({
            type: "ADD_ADMIN_EMAIL",
            success: true
          });
        })
        .catch((err) => {
            //console.log(err)
          dispatch({
            type: "ADD_ADMIN_EMAIL_ERR",
            err
          });
        });
    };
  };